module.exports = {"editor":{"map":"mapa","map_name":"%{name} mapa","map_pluralize":"%{smart_count} mapa |||| %{smart_count} mapas"}}


//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/locale/es.json
// module id = 310
// module chunks = 0 1 2